<template>
<div class="container">
    <div v-for="item in list" :key="item.id">
        <book-item v-bind:books="item"></book-item>
    </div>
</div>
</template>

<script>
import BookItem from '@/components/BookItem.vue'
import {
    getCookie
} from '@/network/cookie.js'
import axios from 'axios'

export default {
    metaInfo() {
        return {
            title: '路上畅听书籍搜索' + this.$store.state.title,
            meta: [{
                    vmid: 'keywords',
                    name: 'keywords',
                    content: this.$store.state.keywords
                },
                {
                    vmid: 'description',
                    name: 'description',
                    content: this.$store.state.description
                }
            ]
        }
    },
    data() {
        return {
            key: '',
            tips: [],
            list: [],
            sessionId: ''
        }
    },
    components: {
        'book-item': BookItem
    },
    methods: {
        searchDataBak: function () {
            if (getCookie('sessionId')) {
                this.sessionId = getCookie('sessionId');
            }
            //let url = '/xcx/search-book?key='+ encodeURIComponent(this.key) +'&sessionId='+this.sessionId+'&pageSize=300&pageIndex=0'
            var datas = {
                key: this.key,
                sessionId: this.sessionId,
                pageSize: 300,
                pageIndex: 0
            }

            this.$http.post('/xcx/search-book?key', datas).then(res => {
                this.list = res.data.data
            })

        },
        searchData: function () {
            const params = new FormData()
            params.append('key', this.key)
            params.append('sessionId', this.sessionId)
            params.append('pageSize', 300)
            axios.post('https://apis.auto-learning.com/v3/xcx/search-book?key', params).then(res => {
                this.list = res.data.data
            })
        }
    },
    watch: {
        '$route'() {
            if (this.$route.query.keyword) {
                this.key = this.$route.query.keyword;
            }
            this.searchData();
        }
    },
    mounted() {
        if (this.$route.query.keyword) {
                this.key = this.$route.query.keyword;
            }
        this.searchData();
    },
}
</script>

<style scoped>
a {
    text-decoration: none;
}

</style>
